<div class="h-100 w-100 d-flex flex-column flex-grow-1 overflow-auto">

    <div class="position-absolute w-100 d-flex" [class.justify-content-end]="isRTL">
        <button type="button" mat-icon-button aria-label="Toggle sidenav" (click)="closeSuAllScreensDialog()"
            class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div
        class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-3 w-100 zx-min-h-modal">
        <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode"
            [class.zx-ltr]="!isRTL">
            {{ "su-management.report.all-screens" | translate }}
        </h4>
        <!-- loading -->
        <div *ngIf="isLoading" class="d-flex w-100 flex-grow-1 justify-content-center align-items-center">
            <mat-spinner class="zx-medium-icon-size"></mat-spinner>
        </div>
        <!-- full inventory container -->
        <div *ngIf="!isLoading" class="d-flex flex-column flex-grow-1 w-100 pb-2">
            <div *ngFor="let cl of clusters" class="d-flex flex-column w-100 pb-4">
                <!-- cluster title -->
                <span class="d-flex pb-2 text-green">
                    <b>
                        {{ "choose-branch.naming." + cl.serial_name | translate }}
                    </b>
                </span>
                <!-- screens -->
                <article class="d-flex w-100 pb-2 row">
                    <div *ngFor="let br of cl.plotter" (click)="openAnydesk('plotter', br)"
                        class="d-flex flex-column justify-content-center col-12 col-md-6 col-lg-4 c-pointer">
                        <span class="d-flex pb-2 text-green">
                            <span>
                                {{ "choose-branch.naming.plotter." + br.serial_name | translate }}
                            </span>
                        </span>
                        <img [src]="getScreenImageUrl('plotter', br)" alt="Screen Image"
                            class="w-100 h-100 object-fit-contain rounded-2 shadow-85">
                    </div>
                    <div *ngFor="let br of cl.express" (click)="openAnydesk('express', br)"
                        class="d-flex flex-column justify-content-center col-12 col-md-6 col-lg-4 c-pointer">
                        <span class="d-flex pb-2 text-green">
                            <span>
                                {{ "choose-branch.naming.express." + br.serial_name | translate }}
                            </span>
                        </span>
                        <img [src]="getScreenImageUrl('express', br)" alt="Screen Image"
                            class="w-100 h-100 object-fit-contain rounded-2 shadow-85">
                    </div>
                </article>
            </div>
        </div>
        <!-- // full inventory container -->

    </div>

</div>